import { FC, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Header } from '../../components/nav';
import ROUTES from './routes';

const Private: FC = () => {
  return (
    <Suspense fallback={<div>loading</div>}>
      <Header />
      <div className="h-[calc(100vh-100px)] overflow-x-hidden">
        <Routes>
          {ROUTES.map(({ path, to, element, index }) => (
            <Route key={Math.random()} path={to ?? path} index={Boolean(index)} element={element} />
          ))}
          <Route path="*" element={<div>error</div>} />
        </Routes>
      </div>
    </Suspense>
  );
};

export default Private;
